'use client';

import { useEffect, useState } from 'react';
import { ScrollArea } from 'components/ui/scroll-area';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';

import { useAudit as useExecuteAudit } from './audit-context';

import { RequestState } from 'interfaces/request';

import { toast } from 'sonner';
import api from '../InternalAudit/api';
import { TaskSelection } from '../InternalAudit/task-selection';
import { useAudit } from '../InternalAudit/audit-context';

export default function ExtendAuditModal() {
  const [request, setRequest] = useState(RequestState.INITIAL);
  const [open, setOpen] = useState(false);
  const { selectedTasks, setSelectedTasks } = useAudit();
  const { audit, tasksMap, setStep } = useExecuteAudit();

  const isDisabled = selectedTasks.length < 1;

  const tasksFilter = tasksMap ? Object.keys(tasksMap) : [];

  useEffect(() => {
    setSelectedTasks([]);
  }, [open]);

  const extendInternalAudit = async () => {
    setRequest(RequestState.PENDING);
    try {
      if (selectedTasks.length < 1) {
        toast.error('Vælg mindst én opgave');
        return;
      }

      console.log({ selectedTasks });

      const { id } = await api.extendInternalAudit({
        taskIds: selectedTasks,
        internalAuditId: audit.id,
      });
      setRequest(RequestState.RESOLVED);

      toast.success('Auditering opdateret');
      setOpen(false);
    } catch (error) {
      console.error(error);
      toast.error('Der skete en fejl. Prøv igen senere.');
      setRequest(RequestState.REJECTED);
    }
  };

  return (
    <>
      <Dialog open={open} onOpenChange={(open) => setOpen(open)}>
        <DialogTrigger>
          <Button
            variant="outline"
            className="w-full sm:w-auto"
            onClick={() => {
              setOpen(true);
              setStep('location');
            }}
          >
            Udvid audit
          </Button>
        </DialogTrigger>

        <DialogContent className="sm:max-w-[900px] p-0 overflow-hidden">
          <div className="flex flex-col sm:flex-row h-[80vh] sm:h-[600px]">
            {/* Left side - fixed content */}
            <div className="w-full sm:w-[300px] bg-muted p-6 flex flex-col">
              <DialogHeader>
                <DialogTitle>Tilføj yderligere til audit</DialogTitle>
                <DialogDescription>Vælg mindst et punkt for at tilføje til audit</DialogDescription>
              </DialogHeader>
              <div className="mt-6 flex-1 flex flex-col gap-4">
                {/* <Label>Vælg audit dato</Label>
                <AuditDatePicker /> */}

                <div className="flex flex-grow" />
                {/* <div className="rounded-md bg-primary/10 p-4"> */}
                {/* <h3 className="font-medium">Actions</h3> */}
                <div className="mt-4 space-y-2">
                  <Button
                    size="sm"
                    className="w-full"
                    disabled={isDisabled}
                    loading={request === RequestState.PENDING}
                    onClick={extendInternalAudit}
                  >
                    Tilføj til auditering
                  </Button>
                </div>
              </div>
            </div>

            {/* Right side - scrollable content */}
            <ScrollArea className="flex-1 border-l">
              <div className="p-6">
                <h2 className="text-xl font-semibold">Tilføj punkter</h2>
                <div className="text-sm text-muted-foreground mb-4">
                  Du kan kun tilføje opgaver til auditeringen, men du kan altid springe dem over
                </div>
                <TaskSelection tasksFilter={tasksFilter} orgId={'selectedLocation'} />
              </div>
            </ScrollArea>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
